import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { Observable } from 'rxjs';
import { ProductosAgremiaciones } from '../_models/productos-agremiaciones';

@Injectable({
  providedIn: 'root'
})
export class ProductosAgremiacionesService {
  private rutaServicio = AppSettings.rutServiciosAPL + '/api/productosAgremiaciones';

  constructor(
    private httpClient: HttpClient,
    private autenticacionService: AutenticacionService
  ) { }

  listado(): Observable<ProductosAgremiaciones[]> {
    return this.httpClient.get<ProductosAgremiaciones[]>(this.rutaServicio);
  }

  obtenerPorId(id: string): Observable<ProductosAgremiaciones> {
    return this.httpClient.get<ProductosAgremiaciones>(`${this.rutaServicio}/${id}`);
  }

  listadoPorProducto(idProducto: string): Observable<ProductosAgremiaciones[]> {
    return this.httpClient.get<ProductosAgremiaciones[]>(`${this.rutaServicio}/idProducto/${idProducto}`);
  }

  listadoPorProductoHabilitados(idProducto: string): Observable<ProductosAgremiaciones[]> {
    return this.httpClient.get<ProductosAgremiaciones[]>(`${this.rutaServicio}/idProducto/${idProducto}/enabled`);
  }

  crearOActualizar(registro: ProductosAgremiaciones): Observable<ProductosAgremiaciones> {
    registro.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductosAgremiaciones>(this.rutaServicio, registro);
  }

  bulk(registros: any[]): Observable<ProductosAgremiaciones[]> {
    const usuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    registros.forEach(r => {
      if (!r.auditoriaUsuario) {
        r.auditoriaUsuario = usuario;
      }
    });
    return this.httpClient.post<ProductosAgremiaciones[]>(`${this.rutaServicio}/bulk`, registros);
  }
}
